export const digitalTrendsCover = '/images/blog/digital-trends-2026.webp';
export const digitalTrendsBanner = '/images/blog/digital-trends-2026-wide.webp';
export const mobileRoiCover = '/images/blog/mobile-app-roi.webp';
export const seoTop3Cover = '/images/blog/seo-top3.webp';
